(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    document.querySelectorAll('.m-product-sticky-atc').forEach(function (bar) {
      var sectionId = bar.dataset.sectionId;
      var productRoot = document.getElementById('MainProduct-' + sectionId);
      var priceSource = document.getElementById('price-' + sectionId);
      var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
      var productForm = document.getElementById('product-form-' + sectionId);
      var stickyAddButton = bar.querySelector('.m-product-sticky-atc__button--add');
      var stickyCheckoutButton = bar.querySelector('.m-product-sticky-atc__button--checkout');
      var stickyAddText = stickyAddButton ? stickyAddButton.querySelector('[data-sticky-submit-label]') : null;
      var stickyPrice = bar.querySelector('.m-product-sticky-atc__price');
      var stickyLabel = bar.querySelector('.m-product-sticky-atc__label');
      var stickyAddon = bar.querySelector('.m-product-sticky-atc__addon');
      var addonCheckbox = document.getElementById('addon-silicone-case');
      var viewed = false;
      var checkoutBusy = false;

      if (!productRoot || !mainButton || !stickyAddButton || !stickyCheckoutButton || !stickyPrice) return;

      function clean(text) {
        return (text || '').replace(/\s+/g, ' ').trim();
      }

      function selectedPackLabel() {
        var selected = productRoot.querySelector('.pack-option--selected');
        if (!selected) return 'BLEShark Nano';
        var name = clean(selected.querySelector('.pack-option__name')?.textContent);
        return name && name !== '1 Device' ? name : 'BLEShark Nano';
      }

      function syncPrice() {
        if (!priceSource) return;
        var sale = priceSource.querySelector('.price--on-sale .price-item--sale');
        var regular = priceSource.querySelector('.price__regular .price-item--regular');
        var fallback = priceSource.querySelector('.price-item');
        var next = clean((sale || regular || fallback)?.textContent);
        if (next) stickyPrice.textContent = next;
        refreshShippingEstimate();
      }

      function refreshShippingEstimate() {
        if (!window.InfiSharkShippingEstimator || typeof window.InfiSharkShippingEstimator.refresh !== 'function') return;
        window.InfiSharkShippingEstimator.refresh(sectionId);
      }

      function syncButton() {
        var text = clean(mainButton.querySelector('span')?.textContent || mainButton.textContent);
        var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        var loading = mainButton.classList.contains('loading');
        stickyAddButton.disabled = disabled;
        stickyCheckoutButton.disabled = disabled || checkoutBusy;
        stickyAddButton.toggleAttribute('aria-disabled', disabled);
        stickyCheckoutButton.toggleAttribute('aria-disabled', disabled || checkoutBusy);
        stickyAddButton.classList.toggle('is-loading', loading);
        if (stickyAddText && text) stickyAddText.textContent = text;
      }

      function syncLabel() {
        if (stickyLabel) stickyLabel.textContent = selectedPackLabel();
      }

      function syncAddon() {
        if (!stickyAddon || !addonCheckbox) return;
        var checked = addonCheckbox.checked;
        var qty = parseInt(addonCheckbox.dataset.currentQty || '1', 10) || 1;
        stickyAddon.hidden = !checked;
        if (!checked) {
          stickyAddon.textContent = '';
          return;
        }
        stickyAddon.textContent = qty > 1 ? '+ ' + qty + ' silicone cases selected' : '+ Silicone case selected';
        refreshShippingEstimate();
      }

      function syncAll() {
        syncPrice();
        syncButton();
        syncLabel();
        syncAddon();
        refreshShippingEstimate();
      }

      function setVisible(visible) {
        bar.classList.toggle('is-visible', visible);
        document.documentElement.classList.toggle('m-product-sticky-atc-visible', visible);
        if (visible && !viewed) {
          viewed = true;
          if (window.InfiSharkAnalytics && typeof window.InfiSharkAnalytics.track === 'function') {
            window.InfiSharkAnalytics.track('mobile_sticky_atc_viewed', {
              section_id: sectionId,
              product: productRoot.dataset.productId || '',
            });
          }
        }
      }

      function track(action) {
        if (!window.InfiSharkAnalytics || typeof window.InfiSharkAnalytics.track !== 'function') return;
        window.InfiSharkAnalytics.track(action, {
          section_id: sectionId,
          pack: window.__infCurrentPack || 'single',
          silicone_case: addonCheckbox && addonCheckbox.checked ? 'true' : 'false',
        });
      }

      stickyAddButton.addEventListener('click', function () {
        syncButton();
        if (stickyAddButton.disabled) return;
        track('mobile_sticky_atc_clicked');
        mainButton.click();
      });

      stickyCheckoutButton.addEventListener('click', function () {
        if (!productForm || stickyCheckoutButton.disabled || checkoutBusy) return;
        checkoutBusy = true;
        syncButton();
        track('mobile_sticky_checkout_clicked');

        var formData = new FormData(productForm);
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response && response.status) {
              checkoutBusy = false;
              syncButton();
              mainButton.click();
              return;
            }
            window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
          })
          .catch(function () {
            checkoutBusy = false;
            syncButton();
            mainButton.click();
          });
      });

      if (priceSource) {
        new MutationObserver(syncPrice).observe(priceSource, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
        });
      }

      new MutationObserver(syncButton).observe(mainButton, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });

      document.addEventListener('infishark:pack-change', function (event) {
        if (!event.detail || event.detail.sectionId !== sectionId) return;
        syncLabel();
        setTimeout(syncAll, 80);
      });

      document.addEventListener('infishark:silicone-change', function () {
        syncAddon();
      });

      document.addEventListener('change', function (event) {
        if (!event.target.closest('#MainProduct-' + sectionId)) return;
        setTimeout(syncAll, 80);
      });

      setVisible(true);
      syncAll();
    });
  });
})();
